import logger from '../../Utils/logger';
import React, { useEffect, useState } from 'react';
import styles from './Style.module.css';
import { BtnPrimary } from '../Buttons/BtnPrimary';
import { PriceBreakdownPopup } from '../Popup/PriceBreakdownPopup/PriceBreakdownPopup';
import { useBookingSession } from '../../Context/BookingSession/BookingSessionContext';

function Cart({
  btnLabel = 'Add',
  btnClick,
  isCartActive = false,
  disabled = false,
  displayTotal = 0,
  displayCount = 0,
  selectedServices,
}) {
  const { rescheduleCount, rescheduleMaxLimit, bookingUpdate } = useBookingSession();
  logger.log(selectedServices, 'selectedServices');
  const [showPriceBreakdown, setShowPriceBreakdown] = useState(false);

  const handleShowPriceBreakDown = () => {
    setShowPriceBreakdown(true);
  };

  const handleClosePriceBreakdown = () => {
    setShowPriceBreakdown(false);
  };




  useEffect(() => {
    const body = document.body;
    body.classList.remove('overlay', 'half', 'overlay-index', 'overflow-hidden');
    if (showPriceBreakdown) {
      body.classList.add('overlay', 'overflow-hidden');
    }
  }, [showPriceBreakdown]);











  if (!isCartActive) return null;


  return (
    <>
    <div data-snackbar-footer="true" className={`${styles.cartCard} ${styles.active}`}>
      <div className={`${styles.cartCardContainer} container space-x`}>
        <div className={styles.cartCardLeft}>
          {bookingUpdate ? (
            <h5>Reschedule Booking {rescheduleCount + 1}/{rescheduleMaxLimit}</h5>
          ) : (
            <h5>
            From Member&apos;s rate S$
            <span>{Number(displayTotal).toFixed(2)}+</span>
          </h5>
          )}
          <h6 
          className={`${styles.cartCardCount} btn`}
          onClick={handleShowPriceBreakDown}
          >
            <span>{displayCount}</span> {displayCount !== 1 ? "Services" : "Service"}
          </h6>
        </div>
        <div className={styles.cartCardRight}>
          <BtnPrimary label={btnLabel} handleClick={btnClick} disabled={disabled} />
        </div>
      </div>
    </div>
    <PriceBreakdownPopup
      displayTotal={displayTotal}
      selectedServices={selectedServices}
      active={showPriceBreakdown}
      onClose={handleClosePriceBreakdown}
    />
    </>
  );
}

export { Cart };
export default Cart;
